import { type Common } from './common.js';
import { type Payout } from './models/payment/payment.js';
import { type PayoutsForAccountIdWithTimeArgs } from './models/payout.js';

export class API {
  common: Common;
  baseEndpoint = '/payouts';

  constructor(common: Common) {
    this.common = common;
  }

  async getPayoutsForAccountIdWithTime(args: PayoutsForAccountIdWithTimeArgs): Promise<Payout[]> {
    const { accountId, paidTimestampStart, paidTimestampEnd } = args;
    const url = this.common.constructPath(this.baseEndpoint, {
      accountId,
      paidTimestampStart,
      paidTimestampEnd,
    });
    const { results } = await this.common.getJSON(url);
    return results;
  }
}
